import $ from 'jquery';
import Plyr from 'plyr';
import 'slick-carousel';
import {TimelineMax, TweenMax} from 'gsap';
import 'gsap/DrawSVGPlugin';
import CountUp from 'countup.js';
import 'select2';
import ScrollMagic from 'scrollmagic';
import 'jquery-popup-overlay';

export default {
  init() {
    // JavaScript to be fired on the home page

    /*
    *  LazySizes data-bg to background-image
    */
    document.addEventListener('lazybeforeunveil', function(e){
      var target = e.target;
      var bg = e.target.getAttribute('data-xrefhref');
      if(bg){
          target.setAttribute('xref:href', bg);
          $(target).insertAfter( $(e.target) );
      }
    });

    // Register button scroll
    $('a[href*="#register"]').on('click', function(e) {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: $('.section--signup').offset().top - 60,
      }, 800);
    });

    $('#reminder_popup').popup({
      opacity: 0.3,
      transition: 'all 0.3s',
    });

    $('#terms_popup').popup({
      opacity: 0.3,
      transition: 'all 0.3s',
    });
    
    // Sections animation when scrolled
    var controller = new ScrollMagic.Controller();
    $('section').each(function(){
        var currentCell = this;

        new ScrollMagic.Scene({triggerElement: currentCell, offset: -100, reverse: false})
            .on('start', function () {
                TweenMax.fromTo(this.triggerElement(), 1.25, {y: 50, opacity: 0}, {y: 0, opacity: 1});
            })
            .addTo(controller);
    });

    // Hero animations
    var $heroItems = $('.hero-item');

    var heroTimeline = new TimelineMax({paused: true});

    heroTimeline.staggerFromTo($('.title-green, .title-swamp'), 1, {opacity: 0, y: 50}, {opacity: 1, y: 0}, 0.8, 1)
                .fromTo($('.title-container__description'), 1, {opacity: 0, y: 50}, {opacity: 1, y: 0}, 2.5)
                .fromTo($('.description-container'), 1, {y: 50, opacity: 0}, {y: 0, opacity: 1}, 2)
                .fromTo($('.work-estonia-svg'), 1, {opacity: 0, y: -50}, {opacity: 1, y: 0}, 1.5)
                .to($('.hero__background svg'), 1, {opacity: 1}, 0.5)
                .staggerFromTo($heroItems, 0.75, {y: 50, opacity: 0}, {y: 0, opacity: 1, ease: 'Sine.easeInOut'}, 0.5, 2)
                .fromTo($('.greeting-container'), 1, {opacity: 0, x: -50}, {opacity: 1, x: 0}, 5)
                .staggerTo($('.bubbles-container .bubble, .scrollhint'), 1, {opacity: 1}, 0.25, 3);

    $heroItems.each(function(index) {
      let $this    = $(this),
          $thisSVG = $this.find('svg line, svg polyline, svg path');

      if ( index == 1 ) {
        heroTimeline.staggerFromTo($thisSVG, 1, {drawSVG: 0, opacity: 0}, {drawSVG: '100%', opacity: 1, ease: 'Sine.easeOut'}, 0.1, 2 + index * 0.5);
      } else {
        heroTimeline.staggerFromTo($thisSVG, 1, {drawSVG: 0, opacity: 0}, {drawSVG: '100%', opacity: 1, ease: 'Sine.easeOut'}, 0.1, 2 + index * 0.5);
      }
    });

    heroTimeline.play();

    // Stars animations
    var starsTimeline = new TimelineMax(),
        $stars    = $('.star');
    starsTimeline.staggerFromTo($stars, 0.25, {opacity: 0}, {opacity: 1, ease: 'Sine.easeInOut'}, 0.25, 1);

    // Cloud & Smoke animations
    var cloudEnterTimeline = new TimelineMax(),
        cloudMoveTimeline  = new TimelineMax(),
        $clouds            = $('.cloud'),
        $cloudPaths        = $clouds.find('line, path'),
        $smoke            = $('.smoke'),
        $smokePaths        = $smoke.find('line, path');

    cloudEnterTimeline.set($cloudPaths, {drawSVG: 0, opacity: 0})
                      .set($smokePaths, {drawSVG: 0, opacity: 0})
                      .staggerTo($cloudPaths, 2, {drawSVG: '100%', opacity: 1, ease: 'Expo.easeInOut'}, 0.05, 0.5)
                      .staggerTo($smokePaths, 2, {drawSVG: '100%', opacity: 1, ease: 'Expo.easeInOut'}, 0.05, 1);

    var $smokesAndClouds = $.merge($clouds, $smoke);
    $smokesAndClouds.each(function(index, element) {
      cloudMoveTimeline.to(element, 2, {
        repeat: -1,
        yoyo:true,
        ease: 'Sine.easeInOut',
        y: function(index) {
          return -10 + index * 2
        },
        scale: (Math.random() * (1 - 1.05) + 1.05).toFixed(4),
      }, index * 0.1);
    });


    // Bubble animation
    $('.bubbles-container .bubble, .scrollhint').each(function(index, element) {
      cloudMoveTimeline.to(element, 2, {
        repeat: -1,
        yoyo:true,
        ease: 'Sine.easeInOut',
        y: function(index) {
          return -10 + index * 10
        },
      }, index * 0.1);
    });

    // Exhaust animations
    var exhaustTimeline = new TimelineMax({repeat: -1, paused: true}),
        // exhaustEnterTimeline = new TimelineMax(),
        $torches        = $('.torch'),
        $flames         = $('.flame');

    exhaustTimeline.set($torches, {drawSVG: 0, opacity: 0})
                   .set($flames, {drawSVG: 0, opacity: 0})
                   .staggerTo($flames, 1, {drawSVG: '100%', opacity: 1, ease: 'Expo.easeInOut'}, 0.1, 0)
                   .staggerTo($torches, 1, {drawSVG: '100%', opacity: 1, ease: 'Expo.easeInOut'}, 0.05, 0)
                   .staggerTo($flames, 1, {drawSVG: '100% 100%', opacity: 0, ease: 'Expo.easeInOut'}, 0.1, 2)
                   .staggerTo($torches, 1, {drawSVG: '100% 100%', opacity: 0, ease: 'Expo.easeInOut'}, 0.05, 2);

    setTimeout(function() {
      exhaustTimeline.play();
    }, 2500);

    // Rocket animation
    var rocketTimeline      = new TimelineMax({repeat: -1, yoyo: true}),
        rocketEnterTimeline = new TimelineMax(),
        $rocket        = $('.rocket');

    rocketEnterTimeline.fromTo($rocket, 2, {yPercent: 25, opacity: 0}, {yPercent: 0, opacity: 1}, 1);
    
    rocketTimeline.to($rocket, 0.10, {x: -0.5})
                  .to($rocket, 0.10, {y: -1}, 0.05)
                  .to($rocket, 0.10, {x: 0.5}, 0.15)
                  .to($rocket, 0.10, {y: 1}, 0.25);

    // Why section read more button
    let whyTimeline         = new TimelineMax({paused: true}),
        $whyContent         = $('.why__content'),
        $whyContentGradient = $('.why__content__gradient'),
        btnDisabled         = false;

    whyTimeline.to($whyContent, 0.5, {className: '-=closed', ease: 'Sine.easeInOut'})
              .to($whyContentGradient, 0.5, {top: '100%'}, 0.25);
              
    $('.why__read-more button').on('click', function() {
      if ( !btnDisabled ) {
        btnDisabled = true;

        if ( $whyContent.hasClass('closed') ) {
          whyTimeline.play();
        } else {
          whyTimeline.reverse();
        }

        setTimeout(function() {
          btnDisabled = false;
        }, 500);
      }
    });

    // Initialize Plyr players
    const players = Array.from(document.querySelectorAll('.video-item')).map(player => new Plyr(player, {
      controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      // ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'fullscreen']
      hideControls: true,
    }));

    // Initialize Slick-Carousel
    var $videosContainer = $('.videos-container');
    $videosContainer.slick({
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      swipe: false,
    });

    // Quotes carousel
    $('.quotes').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      swipe: false,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
    });

    // CountUp.js custom ease & options
    var easingFn = function (t, b, c, d) {
      var ts = (t /= d) * t;
      var tc = ts * t;
      return b + c * (tc + -3 * ts + 3 * t);
    }
    var options = {
      useEasing: true,
      easingFn: easingFn,
      useGrouping: false,
      separator: ',',
      decimal: ',',
    };

    // Reason item click
    var $reasonOverlay = $('.reason-overlay');

    var reasonTimeline = new TimelineMax({paused: true});
    reasonTimeline.set($reasonOverlay, {display: 'flex'})
                  .fromTo($reasonOverlay, 0.5, {scale: 0.95, y: 50}, {opacity: 1, y: 0})
                  .set($reasonOverlay, {className: '+=is-active'});

    
    $(document).click(function(e){
        if ( $reasonOverlay.hasClass('is-active') ) {
          if ($(e.target).is('.reason-overlay__container, .reason-overlay__container *')) {
              return;
          } else {
              reasonTimeline.reverse();  
          }
        }
    });

    $(document).keyup(function(e) {
      if (e.keyCode === 27) {
        if ( $reasonOverlay.hasClass('is-active') ) {
          reasonTimeline.reverse();
        }
      }
    });

    $('.reason-item').on('click', function() {
      let $this   = $(this),
          thisID = $this.data('id');
      var lineTimeline = new TimelineMax();

      $('.reason-overlay__container').removeClass('is-active');
      $('.reason-' + thisID).addClass('is-active');

      if ( !$this.hasClass('seen') ) {
        $('.reason-' + thisID + ' .graph-row__line').each(function() {
          let $this      = $(this),
              thisValue  = $this.data('value'),
              thisCount  = $this.find('.graph-row__line__value').data('value'),
              $thisColor = $this.find('.graph-row__line__color'),
              $thisValue = $this.find('.graph-row__line__value .value');
  
              lineTimeline.to($thisColor, 1, {className: '+=val-' + thisValue}, 0.25);
          
          var valueAnim;
          if ( thisID === 1 ) {
            valueAnim = new CountUp($thisValue[0], 0, thisValue / 100, 2, 2, options);
            valueAnim.start();
          } else {
            valueAnim = new CountUp($thisValue[0], 0, thisCount, 0, 0, options);
            valueAnim.start();
          }
        });
      }

      $this.addClass('seen');
      reasonTimeline.restart();
    });

    $('.reason-overlay__close').on('click', function() {
      reasonTimeline.reverse();
    });

    // Selection items slick
    $('.selection-container').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: false,
      swipe: false,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 762,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });

    // Video selection thumbnails
    // var $selectionItems = $('.selection-item'),
    var $playCaptions   = $('.play-caption');

    $(document).on('click', '.selection-item' ,function() {
      let $this  = $(this),
          thisID = $this.data('id');

      players.forEach(function(player) {
          player.pause();
      });

      new TimelineMax().to($playCaptions.not(':eq(' + thisID + ')'), 0.5, {opacity: 0})
                       .set($playCaptions.not(':eq(' + thisID + ')'), {display: 'none'})
                       .set($playCaptions.eq(thisID), {display: 'block'})
                       .to($playCaptions.eq(thisID), 0.5, {opacity: 1});

      $videosContainer.slick('slickGoTo', thisID);
    });

    $videosContainer.on('afterChange', function(event, slick){
      $('.selection-item').removeClass('is-active');
      $('.selection-item').eq(slick.currentSlide).addClass('is-active');
    });

    var $videosOverlay = $('.section--videos .section__header'),
        $plyrControls  = $('.plyr__controls'),
        playertimeline = new TimelineMax({paused: true});

    playertimeline.to($videosOverlay, 0.5, {opacity: 0})
                  .to($plyrControls, 0.5, {opacity: 1})
                  .set($videosOverlay, {display: 'none'});

    $('.play-button').on('click', function() {
      let activeID = $('.videos-container .slick-active').data('slick-index');
      
      players.forEach(function(player) {
        player.pause();
      });

      players[activeID].play();
    });

    players.forEach(function(player) {
      player.on('playing', function() {
        playertimeline.play();
      });

      player.on('pause', function() {
        playertimeline.reverse();
      });
    });

    const $wpcf7Select = $('.wpcf7-select');

    $wpcf7Select.select2({
      minimumResultsForSearch: Infinity,
      width: '100%',
      placeholder: 'Your current job field',
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js